window.addEventListener( 'load', function() {

	const ctaToggles = document.querySelectorAll( '.toggle' );

	[...ctaToggles].forEach( ctaToggle => {
        const   ctaButton = ctaToggle.querySelector( '.toggle__button' ),
                ctaContent = ctaToggle.querySelector( '.toggle__content' );
        
        if ( ctaButton && ctaContent ) {
            ctaButton.addEventListener( 'click', e => {
                e.preventDefault();
                if ( 'false' === ctaButton.getAttribute( 'aria-expanded' ) ) {
                    ctaButton.setAttribute( 'aria-expanded', true );
                    ctaContent.removeAttribute( 'hidden' );
                } else {
                    ctaButton.setAttribute( 'aria-expanded', false );
                    ctaContent.setAttribute( 'hidden', '' );
                }
            } );
        }		
	} );

} );